<template>
    <section class="q10__page my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head">
                <!-- article title head -->
                <article-title-head
                    :options="{
                        category: currentPage.content.oTitleHead_sCategory.text,
                        phrase: currentPage.content.oTitleHead_sPhrase.text,
                        author: currentPage.content.oTitleHead_sAuthor.text,
                        from: currentPage.content.oTitleHead_nFrom.text,
                        to: currentPage.content.oTitleHead_nTo.text,
                        color: 'text-selective_green',
                    }"
                ></article-title-head>
            </div>

            <div class="q10__article_container__content">
                <div
                    class="
                        q10__article_container__content__vertical_head
                        mx-auto
                        relative
                    "
                >
                    <div class="relative">
                        <article-vertical-head
                            :options="{
                                text: currentPage.content.oVerticalHead_sText
                                    .text,
                                position: 'lg:ml-2 2xl:-ml-8',
                                imageAuthor:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image1.src,
                            }"
                        ></article-vertical-head>

                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Interview de M. Robino'
                                ),
                            }"
                            class="top-6 right-1 lg:right-6"
                        />
                    </div>
                </div>

                <div class="q10__article_container__content__paragraphs">
                    <paragraph-first-letter-big
                        :options="{
                            letter: currentPage.content.firstParagraph.text.substr(
                                0,
                                1
                            ),
                            color: 'text-selective_green',
                        }"
                    />

                    <paragraph :options="{}">
                        <span
                            v-html="
                                currentPage.content.firstParagraph.text.slice(1)
                            "
                        ></span>
                        <!-- <Square
                            :options="{
                                from: 'from-feijoa',
                                to: 'to-selective_green',
                            }"
                        /> -->
                    </paragraph>
                </div>
            </div>
        </div>

        <div class="relative">
            <timeline-carousel
            :options="{
                timeline: currentPage.timeline,
            }"/>
            <hotspot-richmedia
                :options="{
                    icon: 'diaporama',
                    collection: getRichmediaByCollection(
                        currentPage,
                        'Projet national MRCD'
                    ),
                }"
                class="top-2 left-16"
            />
        </div>
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="relative">
                <image-with-descriptions
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.image2.src,
                        descriptions: [
                            {
                                text: currentPage.images.image2.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                        ],
                    }"
                />

                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'SuPerHydro, témoignage de O. Guilhem'
                        ),
                    }"
                    class="top-2 right-2"
                />
            </div>

            <article-note
                :options="{
                    verticalcontent: currentPage.content.verticalContent.text,
                    title: currentPage.content.sTitle.text,
                    content: currentPage.content.secondParagraph.text,
                    color: {
                        verticalcontent: 'text-cornflower_blue',
                        title: 'text-selective_green',
                        content: 'text-nandor',
                    },
                    fontSize: {
                        verticalcontent: 'text-4xl md:text-3xl lg:text-4xl',
                        title: 'text-4xl md:text-3xl lg:text-4xl',
                        content: 'text-md md:text-xl lg:text-xl',
                    },
                    margin: {
                        verticalcontent: 'mt-1',
                    }
                }"
            />
        </div>
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import Paragraph from "../../components/Paragraph.vue";

export default {
    components: { Paragraph },
    name: "Page005",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.article_note {
    @apply overflow-visible;
}

.article_note__VerticalContent {
    margin-top: 4px !important;
}
.q10__article_container {
    &__title_head {
        @apply lg:-mb-10;
    }

    &__content {
        @apply flex flex-col lg:flex-row justify-center;

        &__vertical_head {
            @apply col-auto;
        }

        &__paragraphs {
            @apply col-auto mt-3;
        }
    }

    &__content__paragraphs {
        p {
            @apply text-nandor;
        }
    }
}
</style>

